import React from "react";

export default function GuaranteeIcons({ isFreeItem, isOrnament }) {
  return (
    <ul>
      <li>
        {isOrnament != "ornament-prints" && (
          <p>
            <i className="gf_icon fa fa-flag fa-1x"></i> &nbsp; 100% Made In
            America
          </p>
        )}
      </li>
      <li>
        <p>
          <i className="gf_icon fa fa-plane fa-1x"></i> &nbsp; Next Day Shipping
          Available
        </p>
      </li>
      <li>
        {!isFreeItem && (
          <p>
            <i className="gf_icon fa fa-money fa-1x"></i> &nbsp; 100% Money Back
            Guarantee
          </p>
        )}
      </li>
      <li>
        {!isFreeItem && (
          <p>
            <i className="gf_icon fa fa-tag" fa-1x=""></i> &nbsp; Use Shopify
            Pay to break the price down into 4 easy payments!
          </p>
        )}
      </li>
    </ul>
  );
}
